import { type Theme, makeStyles } from '@material-ui/core';
import MuiAvatar, { type AvatarProps } from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme: Theme) => ({
	avatar: {
		background: theme.palette.secondary.main,
		fontSize: 10,
		height: 32,
		letterSpacing: 1.5,
		width: 32,
	},
}));

// NOTE:
// ./src/modules/Private/Courses/Course.tsx[22:8]
interface IProps {
	children: any;
}

export function Avatar({ children, ...rest }: IProps & AvatarProps) {
	const classes = useStyles();

	return (
		<MuiAvatar className={classes.avatar} {...rest}>
			{children}
		</MuiAvatar>
	);
}
